import config from '../Chatbot/config'
import '../styles/messages.css'

export const MessageRenderer = ({ messages, messagesEndRef }) => {
  return messages.map((msg, index) => {
    if (!msg.text && msg.type !== 'custom') return null

    if (msg.type === 'custom') {
      const CustomComponent = config.customMessages[msg.name]
      return CustomComponent ? (
        <div key={msg.id} className='custom-message-container'>
          <CustomComponent payload={msg.payload} />
        </div>
      ) : null
    }

    const className = msg.type === 'user' ? 'user-message' : 'bot-message'

    return (
      <div
        key={msg.id}
        className={`message-container ${className}`}
        ref={index === messages.length - 1 ? messagesEndRef : null}
      >
        {msg.text}
      </div>
    )
  })
}